export const hexaColors = [
  '#6633CC',
  '#146897',
  '#128D7F',
  '#1C8D12',
  '#B23C91',
  '#B23C58',
  '#670226',
]
